export const PRICE_PROPERTIES = {
  CURRENCY: 'currency',
  COUNTRY: 'country',
  VALUE: 'value',
  MSRP: 'msrp',
  UP_SELL: 'upSell',
  CROSS_SELL: 'crossSell',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  VAT_INCLUDED: 'vatIncluded',
};

export const REQUIRED_PRICE_PROPERTIES = [PRICE_PROPERTIES.VALUE, PRICE_PROPERTIES.START_DATE];

export const PRICE_PROPERTIES_LIST = Object.values(PRICE_PROPERTIES);
